define("shared/components/shared/upgrade/plan-card", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _component2, _service, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@glimmer/tracking",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tPF--plan__item tPF--plan__item--{{@plan.planType}} qa--plan__item--{{@plan.planType}}">
    {{#if (eq @plan.planType "growth")}}
      <div class="tPF--plan__hl tPF--plan__hl--white">
        {{t "authorization.sign_up_trial.growth.card"}}
      </div>
    {{/if}}
    {{!-- Title --}}
    <h2 class="tPF--plan__title">{{t (concat "plans.plan_names." @plan.planType)}}</h2>
    {{!-- Sub title --}}
    <p class="tPF--plan__subTitle qa--plan__subtitle">{{t (concat "authorization.sign_up_trial." @plan.planType ".description")}}</p>
    {{!-- Price Title --}}
    <span class="tPF--plan__priceTitle u--text--light u--text--xs u--text--capitalize u--m__t__xs qa--price_starting_point_text">{{t "authorization.sign_up_trial.from"}}</span>
    {{!-- Price --}}
    <div class="tPF--plan__price u--m__t__xs">
      <sup class="tPF--plan__priceCurrency">{{t "plans.currency_symbol"}}</sup>
      <span class="tPF--plan__priceValue tPF--plan__priceValue--xs u--text--strike u--text--hair qa--plan__price">
        {{div @plan.monthlyPrice 100}}
      </span>
      <span class="tPF--plan__priceDuration">{{t "plans.per_month"}}</span>
      {{svg-jar "arrow-right" class="o--icon--lg o--icon--light tPF--plan__priceIcon"}}
      <span class="tPF--plan__priceValue tPF--plan__priceValue--xs qa--plan__price">
        {{t "authorization.sign_up_trial.try_free"}}
      </span>
    </div>
  
    {{!-- Plan Button --}}
    {{#if (and @onPlanButtonClick (not @showButtonAtBottom))}}
      <span class="u--m__t">
        <Shared::Ui::Button
          data-test-id="button"
          class="tPF--plan__btn"
          @type="proceed"
          @size="large"
          @additional="block"
          @text={{t "authorization.sign_up_trial.button_yes"}}
          {{on "click" @onPlanButtonClick}}
        />
      </span>
    {{/if}}
    {{!-- Highlights / Includes --}}
    <div class="tPF--plan__meta">
      <h5 class="tPF--plan__metaTitle tPF--plan__metaTitle--color">{{t "plans.card.includes"}}</h5>
      {{#each @plan.trialOptInHighlights.includes as |highlight|}}
        <Shared::Upgrade::PlanHighlight
          @description={{highlight}}
          @iconName="nav-right"
        />
      {{/each}}
    </div>
    {{!-- Key Features --}}
    <div class="tPF--plan__meta tPF--plan__meta--lg u--m__0">
      <h5 class="tPF--plan__metaTitle u--text--sm u--m__t__0">{{@plan.trialOptInHighlights.featuresHeader}}</h5>
      {{#each @plan.trialOptInHighlights.keyFeatures as |keyFeature|}}
        <Shared::Upgrade::PlanHighlight
          @description={{keyFeature}}
          @isFeatureList={{true}}
        />
      {{/each}}
    </div>
  
    {{!-- See Everything Modal Link --}}
    <div class="tPF--plan__meta">
      <p class="tPF--plan__metaCol u--m__0">
        <div class="tPF--plan__metaRow">
          {{svg-jar "info" class="o--icon tPF--plan__icon"}}
          <Shared::Ui::Button
            class="tPF--plan__link u--p__0"
            @type="unstyled"
            @text={{t "authorization.sign_up_trial.plan_details_link" planName=@plan.name}}
            {{track "expanded-trial-offer" "click" plan=@plan.planType}}
            {{on "click" (toggle-action "showAllFeaturesModal" this)}}
          />
        </div>
      </p>
    </div>
  
    {{!-- Plan Button --}}
    {{#if (and @onPlanButtonClick @showButtonAtBottom)}}
      <span class="u--m__t">
        <Shared::Ui::Button
          data-test-id="button"
          class="tPF--plan__btn"
          @type="proceed"
          @size="large"
          @additional="block"
          @text={{t "authorization.sign_up_trial.button_yes"}}
          {{on "click" @onPlanButtonClick}}
        />
      </span>
    {{/if}}
  </div>
  
  {{#if this.showAllFeaturesModal}}
    <Shared::Upgrade::AllFeaturesModal
      @plan={{@plan}}
      @isMonthly={{true}}
      @close={{toggle-action "showAllFeaturesModal" this}}
    />
  {{/if}}
  
  */
  {
    "id": "lq792nXR",
    "block": "[[[10,0],[15,0,[29,[\"tPF--plan__item tPF--plan__item--\",[30,1,[\"planType\"]],\" qa--plan__item--\",[30,1,[\"planType\"]]]]],[12],[1,\"\\n\"],[41,[28,[37,1],[[30,1,[\"planType\"]],\"growth\"],null],[[[1,\"    \"],[10,0],[14,0,\"tPF--plan__hl tPF--plan__hl--white\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"authorization.sign_up_trial.growth.card\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,\"h2\"],[14,0,\"tPF--plan__title\"],[12],[1,[28,[35,2],[[28,[37,3],[\"plans.plan_names.\",[30,1,[\"planType\"]]],null]],null]],[13],[1,\"\\n\"],[1,\"  \"],[10,2],[14,0,\"tPF--plan__subTitle qa--plan__subtitle\"],[12],[1,[28,[35,2],[[28,[37,3],[\"authorization.sign_up_trial.\",[30,1,[\"planType\"]],\".description\"],null]],null]],[13],[1,\"\\n\"],[1,\"  \"],[10,1],[14,0,\"tPF--plan__priceTitle u--text--light u--text--xs u--text--capitalize u--m__t__xs qa--price_starting_point_text\"],[12],[1,[28,[35,2],[\"authorization.sign_up_trial.from\"],null]],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tPF--plan__price u--m__t__xs\"],[12],[1,\"\\n    \"],[10,\"sup\"],[14,0,\"tPF--plan__priceCurrency\"],[12],[1,[28,[35,2],[\"plans.currency_symbol\"],null]],[13],[1,\"\\n    \"],[10,1],[14,0,\"tPF--plan__priceValue tPF--plan__priceValue--xs u--text--strike u--text--hair qa--plan__price\"],[12],[1,\"\\n      \"],[1,[28,[35,4],[[30,1,[\"monthlyPrice\"]],100],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"tPF--plan__priceDuration\"],[12],[1,[28,[35,2],[\"plans.per_month\"],null]],[13],[1,\"\\n    \"],[1,[28,[35,5],[\"arrow-right\"],[[\"class\"],[\"o--icon--lg o--icon--light tPF--plan__priceIcon\"]]]],[1,\"\\n    \"],[10,1],[14,0,\"tPF--plan__priceValue tPF--plan__priceValue--xs qa--plan__price\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"authorization.sign_up_trial.try_free\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[28,[37,6],[[30,2],[28,[37,7],[[30,3]],null]],null],[[[1,\"    \"],[10,1],[14,0,\"u--m__t\"],[12],[1,\"\\n      \"],[8,[39,8],[[24,\"data-test-id\",\"button\"],[24,0,\"tPF--plan__btn\"],[4,[38,9],[\"click\",[30,2]],null]],[[\"@type\",\"@size\",\"@additional\",\"@text\"],[\"proceed\",\"large\",\"block\",[28,[37,2],[\"authorization.sign_up_trial.button_yes\"],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,0],[14,0,\"tPF--plan__meta\"],[12],[1,\"\\n    \"],[10,\"h5\"],[14,0,\"tPF--plan__metaTitle tPF--plan__metaTitle--color\"],[12],[1,[28,[35,2],[\"plans.card.includes\"],null]],[13],[1,\"\\n\"],[42,[28,[37,11],[[28,[37,11],[[30,1,[\"trialOptInHighlights\",\"includes\"]]],null]],null],null,[[[1,\"      \"],[8,[39,12],null,[[\"@description\",\"@iconName\"],[[30,4],\"nav-right\"]],null],[1,\"\\n\"]],[4]],null],[1,\"  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tPF--plan__meta tPF--plan__meta--lg u--m__0\"],[12],[1,\"\\n    \"],[10,\"h5\"],[14,0,\"tPF--plan__metaTitle u--text--sm u--m__t__0\"],[12],[1,[30,1,[\"trialOptInHighlights\",\"featuresHeader\"]]],[13],[1,\"\\n\"],[42,[28,[37,11],[[28,[37,11],[[30,1,[\"trialOptInHighlights\",\"keyFeatures\"]]],null]],null],null,[[[1,\"      \"],[8,[39,12],null,[[\"@description\",\"@isFeatureList\"],[[30,5],true]],null],[1,\"\\n\"]],[5]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[1,\"  \"],[10,0],[14,0,\"tPF--plan__meta\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"tPF--plan__metaCol u--m__0\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tPF--plan__metaRow\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"info\"],[[\"class\"],[\"o--icon tPF--plan__icon\"]]]],[1,\"\\n        \"],[8,[39,8],[[24,0,\"tPF--plan__link u--p__0\"],[4,[38,13],[\"expanded-trial-offer\",\"click\"],[[\"plan\"],[[30,1,[\"planType\"]]]]],[4,[38,9],[\"click\",[28,[37,14],[\"showAllFeaturesModal\",[30,0]],null]],null]],[[\"@type\",\"@text\"],[\"unstyled\",[28,[37,2],[\"authorization.sign_up_trial.plan_details_link\"],[[\"planName\"],[[30,1,[\"name\"]]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[28,[37,6],[[30,2],[30,3]],null],[[[1,\"    \"],[10,1],[14,0,\"u--m__t\"],[12],[1,\"\\n      \"],[8,[39,8],[[24,\"data-test-id\",\"button\"],[24,0,\"tPF--plan__btn\"],[4,[38,9],[\"click\",[30,2]],null]],[[\"@type\",\"@size\",\"@additional\",\"@text\"],[\"proceed\",\"large\",\"block\",[28,[37,2],[\"authorization.sign_up_trial.button_yes\"],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showAllFeaturesModal\"]],[[[1,\"  \"],[8,[39,15],null,[[\"@plan\",\"@isMonthly\",\"@close\"],[[30,1],true,[28,[37,14],[\"showAllFeaturesModal\",[30,0]],null]]],null],[1,\"\\n\"]],[]],null]],[\"@plan\",\"@onPlanButtonClick\",\"@showButtonAtBottom\",\"highlight\",\"keyFeature\"],false,[\"if\",\"eq\",\"t\",\"concat\",\"div\",\"svg-jar\",\"and\",\"not\",\"shared/ui/button\",\"on\",\"each\",\"-track-array\",\"shared/upgrade/plan-highlight\",\"track\",\"toggle-action\",\"shared/upgrade/all-features-modal\"]]",
    "moduleName": "shared/components/shared/upgrade/plan-card.hbs",
    "isStrictMode": false
  });

  let PlanCardComponent = (_class = class PlanCardComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "plans", _descriptor, this);

      _initializerDefineProperty(this, "router", _descriptor2, this);

      _initializerDefineProperty(this, "showAllFeaturesModal", _descriptor3, this);
    }

    get groups() {
      const plan = this.plans.plans.find(plan => plan.planType === this.args.plan.planType);
      return this.plans.featureGroups.map(featureGroup => Object.assign({}, featureGroup, {
        features: featureGroup.features.map(feature => Object.assign({}, feature, {
          value: plan[feature.key]
        }))
      }));
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showAllFeaturesModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  })), _class);
  _exports.default = PlanCardComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PlanCardComponent);
});